import script from "./comment.vue?vue&type=script&setup=true&lang=js"
export * from "./comment.vue?vue&type=script&setup=true&lang=js"

import "./comment.vue?vue&type=style&index=0&id=783ee9bc&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783ee9bc"]])

export default __exports__